module.exports = __webpack_public_path__ + "img/acount-statement.7d498157.svg";